import React from "react";

export const Repas = () => {
  return (
    <section className="bg-gradient-to-r from-red-500 to-indigo-500 text-gray-100 p-8 lg:h-full">
      <div className="container mx-auto flex flex-col lg:flex-row items-center justify-center lg:justify-around lg:px-8">
        {/* Image Repas */}
        <div className="w-full lg:w-2/5 flex justify-center lg:mb-10">
          <img
            className="w-full h-auto max-w-sm lg:max-w-md rounded-xl m-5"
            src="/Assets/img/repas-equilibre.jpg"
            alt="image_repas équilibre"
            title="image_repas équilibre"
          />
        </div>

        {/* Text content */}
        <div className="w-full lg:w-3/5 p-4 lg:p-12">
          <div className="my-2">
            <h5
              id="text-grain"
              className="font-semibold text-2xl md:text-3xl lg:text-5xl text-cyan-300">
              Les repas sont préparés sur place
            </h5>
          </div>
          <p className="text-white mt-4">
            Les repas sont préparés sur place avec des produits frais et de
            saison
          </p>
          <p className="text-white mb-10 lg:mb-5">
            (prix du repas compris dans le tarif horaire hors alimentation
            lactée pour les bébés).
          </p>
          <p className="text-white mb-10 lg:mb-5">
            Nous travaillons avec des producteurs locaux et bio lorsque c'est
            possible.
          </p>
        </div>
      </div>

      <div id="" className="w-full -mt-12 -z-10"></div>
    </section>
  );
};
